(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["franquias"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('FrForm');
  if (!form) return;
  var msg = document.getElementById('FrMsg');
  var btn = form.querySelector('.fr-btn');
  var rotulo = btn ? btn.textContent : '';

  function aviso(texto, ok) {
    if (!msg) return;
    msg.hidden = false;
    msg.textContent = texto;
    msg.classList.toggle('is-erro', !ok);
    msg.classList.toggle('is-ok', !!ok);
  }

  // Marca o campo culpado e leva o foco ate ele. Sem isto a pessoa le "telefone
  // invalido" e precisa procurar sozinha qual dos quatro campos e.
  function culpado(nome) {
    form.querySelectorAll('[aria-invalid]').forEach(function (c) { c.removeAttribute('aria-invalid'); });
    var campo = form.querySelector('[name="' + nome + '"]');
    if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (btn && btn.disabled) return;

    var dados = new FormData(form);
    var nome = (dados.get('nome') || '').toString().trim();
    var email = (dados.get('email') || '').toString().trim();
    var tel = (dados.get('telefone') || '').toString().trim();
    var uf = (dados.get('estado') || '').toString().trim();

    // Validacao aqui e so para o retorno ser imediato. Quem manda e o servidor,
    // que revalida tudo: confiar no navegador seria confiar em quem envia.
    if (!nome) { culpado('nome'); return aviso('Informe seu nome.'); }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { culpado('email'); return aviso('Confira o e-mail.'); }
    if (tel.replace(/\D/g, '').length < 10) { culpado('telefone'); return aviso('Confira o telefone, com DDD.'); }
    if (!uf) { culpado('estado'); return aviso('Escolha o estado de interesse.'); }

    if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }
    aviso('', true);
    if (msg) msg.hidden = true;

    fetch('/apps/franquias/lead', { method: 'POST', body: dados })
      .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
      .then(function (d) {
        if (!d || !d.ok) throw new Error((d && d.erro) || 'falhou');
        // Troca o formulario inteiro pela confirmacao: deixar os campos na tela
        // convida a reenviar, e o segundo envio viraria lead duplicado.
        form.replaceChildren();
        var ok = document.createElement('p');
        ok.className = 'fr-form__msg is-ok';
        ok.textContent = 'Recebemos seu interesse. Entraremos em contato assim que o programa for lançado.';
        form.appendChild(ok);
      })
      ['catch'](function (err) {
        if (btn) { btn.disabled = false; btn.textContent = rotulo; }
        var m = (err && err.message) || '';
        aviso(m && m !== 'falhou' ? ('Não consegui enviar: ' + m + '.') : 'Não consegui enviar agora. Tente de novo em instantes.');
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
		super();
		}

		connectedCallback() {
		this.header = document.querySelector('.section-header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
		this.headerBounds = {};

		this.setHeaderHeight();

		window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky');
		};

		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		}

		setHeaderHeight() {
		document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
		}

		disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
		}

		onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			this.header.classList.add('scrolled-past-header');
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			this.header.classList.add('scrolled-past-header');
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
				this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			this.header.classList.remove('scrolled-past-header');
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
		}

		hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
		this.closeSearchModal();
		}

		reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
		}

		reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		}

		closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
		this.disclosures.forEach(disclosure => disclosure.close());
		}

		closeSearchModal() {
		this.searchModal = this.searchModal || this.header.querySelector('details-modal');
		this.searchModal.close(false);
		}
	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
